import IconButton from 'components/atoms/button/IconButton'
import withModal from 'lib/helpers/hoc/withModal'
import { useGiveOrderFeedback } from 'lib/hooks/mutations/Employee/useGiveOrderFeedback'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    toggleModal?: () => void
    data: any
}

const ConfirmOrderFeedback: FC<Props> = ({ toggleModal, data }) => {

    const { t } = useTranslation()

    const { mutateAsync, isLoading } = useGiveOrderFeedback()

    const GiveFeedback = () => {

        if (isLoading) return
        mutateAsync({

            order_id: data.order_id,
            status: data.status
        }).then(() => {
            toggleModal && toggleModal()
        })
    }

    return (
        <div className="w-full">

            <p className="font-inter-medium text-[#282D46] text-[20px] mt-[10px] max-w-[475px]">
                {t("This action is irreversible, are you sure you want to proceed?")}
            </p>
            <div className="flex justify-end gap-5 mt-[53px]">
                <IconButton
                    onClick={() => {
                        toggleModal && toggleModal();
                    }}
                    secondary={true}
                    type="button"
                    className="w-full max-w-[150px]"
                >
                    {t("No")}
                </IconButton>
                <IconButton
                    onClick={GiveFeedback}
                    type="button"
                    className="w-full max-w-[150px] text-white"
                >
                    {t("Yes")}
                </IconButton>
            </div>
        </div>
    )
}

export default withModal(ConfirmOrderFeedback)